<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <nav
        class="breadcrumb-container d-flex align-items-center justify-content-between mb-3 mt-md-0 mt-4"
      >
        <div class="d-flex align-items-center flex-wrap gap-2">
          <!-- Back Button -->
          <a
            class="back-link d-flex align-items-center justify-content-center me-3"
            routerLink="/api/{{ appId }}"
            [title]="'COMMON.BACK' | translate"
          >
            <mat-icon>arrow_back</mat-icon>
          </a>

          <!-- Application Info -->
          <div class="d-flex align-items-center me-2">
            <div
              class="avatar-wrapper position-relative border rounded flex-shrink-0"
              style="width: 36px; height: 36px; overflow: visible"
            >
              <div
                style="width: 100%; height: 100%; overflow: hidden"
                class="rounded"
              >
                <img
                  [src]="getDocThumbnail(applicationForm.data['logo'])"
                  class="w-100 h-100"
                  style="object-fit: contain"
                  alt="{{ appName }}"
                />
              </div>
            </div>
            <div class="ms-3">
              <h6 class="mb-0 text-dark lh-1 text-wrap text-break">
                {{ appName }}
              </h6>
            </div>
          </div>
          <!-- Separator -->
          <i class="bx bx-chevron-right text-muted mx-2 opacity-50"></i>
          <div class="d-flex align-items-center">
            <div class="me-2 d-flex align-items-center justify-content-center">
              <i class="bx bx-network-chart text-primary"></i>
            </div>
            <h6 class="mb-0 text-dark text-wrap text-break">{{'API.CUSTOM_APIS' | translate }}</h6>
          </div>
        </div>
      </nav>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 col-xl-6 px-2">
        <div class="card half-screen">
          <div class="card-header">
            <div
              class="d-flex justify-content-between align-items-center flex-wrap"
            >
              <h5 class="mb-0">{{'API.API_LIST' | translate}}</h5>
              <button
                mat-stroked-button
                color="primary"
                matTooltip="Add New Api"
                (click)="resetForm()"
              >
                <mat-icon class="me-2">add</mat-icon>
                {{'API.ADD_NEW' | translate}}
              </button>
            </div>
          </div>

          <div class="card-body card-body-list">
            <ul class="list-group w-100">
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
                *ngFor="let e of customApisList; let i = index"
              >
                <a href="javascript:void(0)" (click)="get(e['id'])">
                  {{ e["name"] }}
                </a>
                <span>
                  <a
                    title="Delete"
                    class="ms-1"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteModal"
                    (click)="setSelectedItem(e.id)"
                  >
                    <i class="bx bxs-trash text-danger"></i>
                  </a>
                </span>
              </li>
            </ul>
          </div>

          <div class="card-body p-0">
            <app-api-docs
              [endpoints]="endpoints"
              [usecaseCode]="usecaseCode"
              [server]="api_server"
              [api_schema]="api_schema"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xl-6 px-2">
        <div class="card">
          <div class="card-header">
            <h5>
              {{ form.data["title"] }}  {{'API.CUSTOM_APIS' | translate}}
              <span *ngIf="form.data['id'] > 0"> Edit </span>
              <span *ngIf="form.data['id'] == 0"> Add</span>
            </h5>
          </div>
          <div class="card-body half-screen">
            <!-- Error/Success Message -->
            <p *ngIf="form['error'] == false && form['message']">
              <app-ncs-alert [message]="form['message']" type="success" />
            </p>
            <p *ngIf="form['error'] == true && form['message']">
              <app-ncs-alert [message]="form['message']" type="danger" />
            </p>

            <div class="card-body">
              <form #uiForm="ngForm" class="compact-inputs dropdown-pd-none">
                <!-- Name Field -->
                <div class="row mb-3">
                  <label for="name" class="col-sm-3 col-form-label fw-medium"
                    >{{'API.NAME' | translate}}</label
                  >
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        required
                        [(ngModel)]="form.data['name']"
                        id="name"
                        name="name"
                        placeholder="{{'API.FORM.NAME_PLACE' | translate}}"
                      />
                    </mat-form-field>
                    <mat-error *ngIf="form.inputerror['name']">
                      {{ form.inputerror["name"] }}
                    </mat-error>
                  </div>
                </div>

                <!-- Description Field -->
                <div class="row mb-3">
                  <label
                    for="description"
                    class="col-sm-3 col-form-label fw-medium"
                    >{{'API.DESCRIPTION' | translate}}</label
                  >
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        [(ngModel)]="form.data['description']"
                        id="description"
                        name="description"
                        placeholder="{{'API.FORM.DESCRIPTION_PLACE' | translate}}"
                      />
                    </mat-form-field>
                    <mat-error *ngIf="form.inputerror['description']">
                      {{ form.inputerror["description"] }}
                    </mat-error>
                  </div>
                </div>

                <!-- URL Field -->
                <div class="row mb-3">
                  <label for="url" class="col-sm-3 col-form-label fw-medium"
                    >{{'API.URL' | translate}}</label
                  >
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        [(ngModel)]="form.data['url']"
                        id="url"
                        name="url"
                        placeholder="{{'API.FORM.URL' | translate}}"
                      />
                    </mat-form-field>
                    <mat-error *ngIf="form.inputerror['url']">
                      {{ form.inputerror["url"] }}
                    </mat-error>
                  </div>
                </div>

                <!-- Rule Field (Textarea) -->
                <div class="row mb-3">
                  <label for="rule" class="col-sm-3 col-form-label fw-medium"
                    >{{'API.RULE' | translate}}</label
                  >
                  <div class="col-sm-9 textarea-container">
                    <mat-form-field appearance="outline" class="w-100">
                      <textarea
                        matInput
                        [(ngModel)]="form.data['rule']"
                        id="rule"
                        name="rule"
                        rows="5"
                        placeholder="{{'API.FORM.RULE' | translate}}"
                      ></textarea>
                    </mat-form-field>
                    <mat-error *ngIf="form.inputerror['rule']">
                      {{ form.inputerror["rule"] }}
                    </mat-error>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="card-footer d-flex justify-content-end">
            <button
              mat-stroked-button
              color="primary"
              (click)="save()"
              [disabled]="!uiForm.valid"
              type="button"
            >
              <mat-icon>save</mat-icon> {{'API.SAVE' | translate}}
            </button>
          </div>
        </div>

        <div class="card" *ngIf="form.data['id'] > 0">
          <div class="card-body">
            <!-- Header -->
            <div class="d-flex align-items-center mb-4">
              <mat-icon class="text-primary me-2">play_circle</mat-icon>
              <h5 class="mb-0">{{ form.data["name"] }} Execute</h5>
            </div>

            <form #uiForm="ngForm" class="compact-inputs">
              <!-- Input Data Section -->
              <div class="row mb-4">
                <label
                  for="rule"
                  class="col-12 col-form-label text-start fw-semibold"
                >
                  Input Data
                  <span class="text-secondary fw-normal d-block small"
                    >for execution</span
                  >
                </label>
                <div class="col-12 textarea-container">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Enter execution data</mat-label>
                    <textarea
                      matInput
                      [value]="test_data"
                      id="rule"
                      name="rule"
                      rows="5"
                      (input)="update_testdata($event)"
                      placeholder="Paste your input data here..."
                    ></textarea>
                  </mat-form-field>
                </div>
              </div>

              <!-- Execute Button -->
              <div class="d-flex justify-content-end mb-4">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="execute()"
                  type="button"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Execute
                </button>
              </div>

              <!-- Response Section -->
              <div class="row">
                <div class="col-12">
                  <div class="d-flex align-items-center mb-2">
                    <mat-icon class="text-success me-2">code</mat-icon>
                    <h6 class="mb-0">Response:</h6>
                    <div class="bg-light">
                      <pre>{{ exe_result }}</pre>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="deleteModal"
    tabindex="-1"
    aria-labelledby="deleteModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteModalLabel">Confirm Deletion</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">Are you sure you want to delete this item?</div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-danger"
            (click)="confirmDelete()"
            data-bs-dismiss="modal"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
